/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    }
*/
export default {
  /** 获取列表 */
  PURCHASE_RETURN_LIST_API: '/sales/purchaseReturn/listPurchaseReturnByPage',
  /** 保存/创建 */
  ADD_PURCHASE_RETURN_API: '/sales/purchaseReturn/savePurchaseReturn',
  /** 提交 */
  SUBMIT_PURCHASE_RETURN_API: '/sales/purchaseReturn/savePurchaseReturn',
  // 更新实际出库数量
  UPDATE_ACTUALQUANTITY_API: '/sales/purchaseReturn/updateActualQuantity',
  /** 查询详情 */
  UPDATE_PURCHASE_RETURN_API: '/sales/purchaseReturn/getPurchaseReturn',
  /** 删除 */
  DELETE_PURCHASE_RETURN_API: '/sales/purchaseReturn/deletePurchaseReturn',
  /** 生成物流运输单 */
  SAVE_DELIVERY: '/warehouse/delivery/saveDelivery',
  /** 业务入库单号列表-根据供应商编码和出库仓库编码查询 */
  LIST_BASSINESS: '/warehouse/businessInbound/getBusinessInboundMsg',
  /**业务入库批次列表 */
  LIST_INBOUND: '/warehouse/businessInbound/listBusinessInboundByPage',
  /** 根据单价和数量计算金额 */
  GET_AMOUNT: '/sales/orderSalesReturn/getReturnMoneyAmount',
  /** 查询未全部物流出库的采购退换货单数据 */
  LIST_FOR_TRANSPROT: '/sales/purchaseReturn/listNoAllOutboundPurchaseReturnDetailByPage',
  /** 可退货数量 */
  GET_REST_QUANTITY: '/sales/purchaseReturn/getRestQuantity',
  // 退货数量点击单个批次查询可用库存数量和单价接口
  GET_STORAGEFORPURCHASERETURN: '/warehouse/storageBatch/getStorageForPurchaseReturn',
  //原币本币
  GET_RETURN_AMOUNT: '/sales/purchaseReturn/getReturnMoneyAmount',
  //调拨单生成运输单查重
  CALC_PICK_DELIVERY: '/warehouse/delivery/listDeliveryBillByOtherNo',
  //切换公司获取币种类型
  GET_LEGER_CODE_NAME: '/maindata/ledger/codeName',
  //货币转换接口
  CHANGE_LEGER_CODE_NAME: '/sales/orderSalesReturn/getBasicInfoCurrency',
  //采购货币转换
  PURCH_CHANGE_LEGER_CODE_NAME: '/sales/purchaseReturn/getBasicInfoCurrency',
  // 合同单价货币转换
  GET_EXCHANGE_CURRENCY: '/warehouse/storageLade/getExchangeCurrency',
  //计算金额
  CALCULATE_AMOUNT: '/sales/purchaseReturn/calculateAmount',
  /** 加法计算 */
  GET_ADD_AMOUNT: '/sales/orderSalesReturn/getAddAmount',
  // ============ sunxueping 批量过帐 ============
  PURCHASE_RETURN_VOUCHER: '/sales/purchaseReturn/batchSyncVoucher',
  PURCHASE_RETURN_SIGN_VOUCHER: '/sales/purchaseReturn/batchSignSyncVoucher',
  // ================================================
  //确认
  DO_CONFIRM: '/sales/purchaseReturn/doConfirm',
  // 冲销
  DO_REVERSE: '/sales/purchaseReturn/doReverse',
  // 撤回
  DO_WITHDRAW: '/sales/purchaseReturn/doWithdraw',
  // 退货批次号
  GET_STORAGEFORPURCHASERETURN_PAGE: '/warehouse/storageBatch/queryStorageForPurchaseReturnPage',
};
